export default __webpack_public_path__ + "static/media/factionlessart_hd.669342b7.webp";